<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .empty-state-wrapper {
    align-items: center;
    display: flex;
    flex: 1;
    height: 100%;
    justify-content: center;
    width: 100%;

    .empty-state-text {
      @include colors.color(textGrey);
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      .empty-state-header {
        @include mixins.body2();
        margin: 0;
        text-align: center;
      }
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";

  import {
    activePopUpModalStore,
    candidateStore,
    selectedBackgroundTabStore,
    showEditContact,
  } from "../../stores";

  let isResume = $derived($selectedBackgroundTabStore === "resume");

  let { buttonIconClasses, buttonText, headerText, iconClasses } = $derived(
    isResume
      ? {
          buttonIconClasses: "fa-regular fa-arrow-up-from-bracket",
          buttonText: "Upload resume",
          headerText: "No resumes uploaded yet",
          iconClasses: "fa-solid fa-file",
        }
      : {
          buttonIconClasses: "fa-regular fa-plus",
          buttonText: "Add url",
          headerText: "Add a LinkedIn url to view their background here",
          iconClasses: "fa-brands fa-linkedin",
        }
  );

  const onCtaClick = () => {
    if (isResume) {
      activePopUpModalStore.set({
        modal: "uploadCV",
        candidateId: $candidateStore.candidateId,
      });
    } else {
      showEditContact.set(true);
    }
  };
</script>

<div class="empty-state-wrapper">
  <NoData>
    <IconScale
      slot="icons"
      backgroundColor="interfaceSwGrey_10"
      color="interfaceSwGrey_20"
      class={iconClasses}
      size="xl"
    />
    <div slot="text" class="empty-state-text">
      <span class="empty-state-header">{headerText}</span>
    </div>
    <div slot="buttons">
      <Button
        kind="tertiary"
        size="small"
        leadingIcon={buttonIconClasses}
        onclick={onCtaClick}
      >
        {buttonText}
      </Button>
    </div>
  </NoData>
</div>
